<template>
  <b-modal id="modal-cadastro"
           no-close-on-backdrop
           no-close-on-esc
           size="lg"
           class="no-padding"
           hide-header>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-row align-h="end">
          <div v-if="read">
            <b-button size="sm"
                      class="mr-2 btn-gray"
                      variant="outline"
                      @click="$bvModal.hide('modal-cadastro')">
              Voltar
            </b-button>
            <div class="btn p-0"
                 @click="changeRead">
              <button type="reset"
                      class="mr-3 btn btn-sm btn-rounded btn-secondary">
                Editar informações
              </button>
            </div>
          </div>
          <div v-if="!read">
            <b-button size="sm"
                      class="mr-2 btn-gray"
                      variant="outline"
                      @click="$bvModal.hide('modal-cadastro')">
              Voltar
            </b-button>
            <b-button size="sm"
                      type="submit"
                      class="mr-3"
                      :disabled="disabledNextStep()">
              {{ form.editar ? `Atualizar` : `Adicionar` }}
            </b-button>
          </div>
        </b-row>
      </div>
    </template>
    <div v-if="read">
      <BoxVisualizacao :form="form"
                       :tipo="tipo" />
    </div>

    <div v-if="!read">
      <div class="col-12">
        <div class="row">
          <div v-if="form.cpf !== undefined"
               class="col-4">
            <div role="group"
                 class="form-group">
              <label for="input-live"
                     class="label">CPF:</label>
              <b-form-input
                v-model="form.cpf"
                v-mask="{mask:'999.999.999-99', skipOptionalPartCharacter: ''}"
                :placeholder="`000.000.000-00`"
                :required="tipo == 'Solicitante'"
                size="sm"
                trim />
            </div>
          </div>
          <div role="group"
               class="col-6 form-group">
            <label v-if="tipo === 'Funerária'"
                   for="input-live"
                   class="label">Nome da {{ tipo }}:</label>

            <label v-else
                   for="input-live"
                   class="label">Nome do {{ tipo }}:</label>
            <b-form-input
              v-model="form.nome"
              autocomplete="chrome-off"
              :placeholder="`Nome ${ tipo }`"
              size="sm"
              required
              trim />
          </div>
        </div>
      </div>

      <div class="col-10">
        <div class="row">
          <div v-if="form.telefone !== undefined"
               class="col-4">
            <div role="group"
                 class="form-group">
              <label for="input-live"
                     class="label">Telefone:</label>
              <b-form-input
                :id="`telefone_${_uid}`"
                v-model="form.telefone"
                v-mask="{ mask: '(99)9999-9999', skipOptionalPartCharacter: '' }"
                autocomplete="chrome-off"
                :name="`telefone_${_uid}`"
                :placeholder="`Telefone ${ tipo }`"
                :required="tipo == 'Solicitante'"
                size="sm"
                trim
                @input="validateField()" />
              <span v-if="erros.find((e) => e.field === `telefone_${_uid}`)"
                    class="text-invalid">
                {{ erros.find((e) => e.field === `telefone_${_uid}`).erro }}
              </span>
            </div>
          </div>
          <div v-if="form.celular !== undefined"
               class="col-4">
            <div role="group"
                 class="form-group">
              <label for="input-live"
                     class="label">Celular:</label>
              <b-form-input
                v-model="form.celular"
                v-mask="{ mask:'(99)99999-9999', skipOptionalPartCharacter: '' }"
                :placeholder="`Celular ${ tipo }`"
                :required="tipo == 'Solicitante'"
                size="sm"
                trim />
            </div>
          </div>
          <div v-if="form.email !== undefined"
               class="col-4">
            <div role="group"
                 class="form-group">
              <label for="input-live"
                     class="label">Email:</label>
              <b-form-input
                :id="`email_${_uid}`"
                v-model="form.email"
                autocomplete="chrome-off"
                :name="`email`"
                :placeholder="`Email ${ tipo }`"
                :required="tipo == 'Solicitante'"
                size="sm"
                trim
                @input="validateField()" />
              <span v-if="erros.find((e) => e.field === `email_${_uid}`)"
                    class="text-invalid">
                {{ erros.find((e) => e.field === `email_${_uid}`).erro }}
              </span>
            </div>
          </div>
          <div class="col-3">
            <div v-if="form.ativo !== undefined">
              <div v-if="!read"
                   role="group"
                   class="form-group">
                <label for="input-live"
                       class="label">Ativo:</label>
                <b-form-checkbox v-model="form.ativo"
                                 switch
                                 value="1" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <BoxEndereco :data="form.endereco"
                     @onEnderecoAdd="changeData" />
      </div>
    </div>
  </b-modal>
</template>

<script>
  /* components */
  import BoxVisualizacao from "./BoxVisualizacao"
  import BoxEndereco from "../BoxEndereco"

  /* services */
  import EnderecosService from "@/services/Enderecos"

  /* libraries */
  import { Validator } from 'vee-validate'

  export default {
    name: "BoxModal",
    components: {
      BoxVisualizacao,
      BoxEndereco,
    },
    props: ["form", "read", "tipo"],
    data () {
      return {
        erros: []
      }
    },
    methods: {
      /** Fazemos esse tipo de validação, pois o v-validate apresenta um erro quando está sendo utilizado dentro de um v-if */
      async validateField () {
        if (this.form.telefone && this.form.telefone.replace(/[_()-]/g,'').length <= 10) {
          await this.validateFieldErros(this.form.telefone, { regex: /\(\d{2,}\)\d{4,}\-\d{4}/g }, `telefone_${this._uid}`)
        }

        if (!this.form.telefone) {
          await this.removeErros(`telefone_${this._uid}`)
        }

        if (this.form.email) {
          await this.validateFieldErros(this.form.email, 'email', `email_${this._uid}`)
        }

        if (!this.form.email) {
          await this.removeErros(`email_${this._uid}`)
        }
      },
      async validateFieldErros (field, verify, fieldName) {
        const { valid, errors } = await new Validator().verify(field, verify)

        const index = this.erros.findIndex((e) => e.field === fieldName)

        if (!valid && index === -1) {
          this.erros.push({ field: fieldName, erro: errors[0] })
        }

        if ((valid && index >= 0) || !field) {
          this.erros.splice(index, 1)
        }
      },
      removeErros (fieldName) {
        const index = this.erros.findIndex((e) => e.field === fieldName)

        if (index >= 0) {
          this.erros.splice(index, 1)
        }
      },
      disabledNextStep () {
        return (!!this.form.nome && !!this.form.endereco.uf && !!this.form.endereco.cidade && !this.erros.length) ? false : true
      },
      changeRead () {
        this.$emit('changeRead')
      },
      changeData (data) {
        this.$emit('onEnderecoAdd', EnderecosService.addressStructure(data))
      },
    }
  }
</script>

<style lang="scss">
  @import "@/scss/_utilities/_exports";

  .text-invalid {
    font-size: 14px;
    color: #ED0909;
  }

  .endereco_header{
    background-color: $color-gray-light;
    padding: 10px 0;
    padding-left: 10px;
    font-size: pxToRem(16);
    font-weight: 500;
    padding: pxToRem(8);
  }

  .btn-gray{
    background-color: $sinoreg-card-gray;
  }
</style>
